import { ToolbarPanelOptions } from '@parspec/pixel/dist/esm/components/AgGridTable/CustomToolbarPanel';

export const RESEND_MESSAGE = 'Daily invitation limit reached for this user. Please wait 24 hours and try again.';
export const TOOLBAR_OPTIONS: ToolbarPanelOptions = ['search', 'clearFilters'];
export const DEAFULT_SNACKBAR_MSG = 'Something went wrong, please try again!';
export const DISABLED_ACCESS_MSG = 'Deactivated users will not be charged for Product Finder. You can reactivate user to edit their access.';
